var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-cell",style:({ backgroundColor: _vm.cellData ? _vm.cellData : ''})})
}
var staticRenderFns = []

export { render, staticRenderFns }